//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { TrackingIdPrefix } from '@models/TrackingId';

export const MEDIA_FILTER_TRACKING_ID_PREFIX: TrackingIdPrefix =
  'media-filters-';

export const MediaFilterTrackingIds = {
  USERNAMES_HASHTAGS_FILTER_SEARCH_BAR: `${MEDIA_FILTER_TRACKING_ID_PREFIX}usernames-hashtags-filter-search-bar`,
  USERNAMES_HASHTAGS_FILTER_CHIP_SET: `${MEDIA_FILTER_TRACKING_ID_PREFIX}usernames-hashtags-filter-chip-set`,
  VISUAL_TAGS_FILTER_SEARCH_BAR: `${MEDIA_FILTER_TRACKING_ID_PREFIX}visual-tags-filter-search-bar`,
  VISUAL_TAGS_FILTER_CHIP_SET: `${MEDIA_FILTER_TRACKING_ID_PREFIX}visual-tags-filter-chip-set`,
};
